// extracted by mini-css-extract-plugin
export var clone = "_ov-2";
export var displayNone = "_ov-4";
export var expandableItem = "_ov-5";
export var expanded = "_ov-6";
export var folderItem = "_ov-7";
export var ghost = "_ov-1";
export var hidden = "_ov-3";
export var pipeContainer = "_ov-8";
export var wrapper = "_ov-0";